
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.25 3a1 1 0 011-1h14a1 1 0 110 2v7a2 2 0 01-2 2h-4v3h1a1 1 0 110 2h-4a1 1 0 110-2h1v-3h-4a2 2 0 01-2-2V4a1 1 0 01-1-1zm13 1h-10v7h10V4z","fill":"#B4BCCF"}})])
          )
        }
      }
    